export const CHANGE_MAP_LAYERS_LIST_VISIBILITY = "change-map-layers-list-visibilty";

interface ChangeMapLayersListVisibility {
    type: typeof CHANGE_MAP_LAYERS_LIST_VISIBILITY,
    payload: boolean
}

export type MapActionTypes = ChangeMapLayersListVisibility;
